import { useQuery } from '@tanstack/react-query';
import useApiStore from '../../store/useApiStore';
import { ICampaign } from '../../types';
import { CAMPAIGNS_KEY } from '../../utils/constants';
import Api from '../Api';

interface RESPONSE {
  content: ICampaign[];
  empty: boolean;
  first: boolean;
  number: number;
  numberOfElements: number;
  size: number;
  totalElements: number;
  totalPages: number;
}

interface Parameters {
  page: number;
  size: number;
  sort: string;
  name: string;
}

export default function useGetCampaigns(params?: Parameters) {
  const { onError } = useApiStore();

  return useQuery<RESPONSE, Error>({
    queryKey: [CAMPAIGNS_KEY, params],
    queryFn: async () => {
      const api = new Api({ onError });

      const data: RESPONSE = await api.get({
        url: 'api/v1/campaigns',
        params,
      });

      return data;
    },
  });
}
